import HttpResponse from "../../../../../utils/http/http.response";

export enum DriverPlanNotAcceptableResponseErrorType {
  NO_TAXI_DRIVER_ASSOCIATION = "NO_TAXI_DRIVER_ASSOCIATION",
  NO_VALID_TAXI_DRIVER_CONTRACT = "NO_VALID_TAXI_DRIVER_CONTRACT",
  NO_VALID_TAXI_RAILY_CONTRACT = "NO_VALID_TAXI_RAILY_CONTRACT",
  NO_VALID_CARGO_RAILY_CONTRACT = "NO_VALID_CARGO_RAILY_CONTRACT",
  TARGET_PLAN_ENTRY_NOT_FOUND = "TARGET_PLAN_ENTRY_NOT_FOUND",
  CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME = "CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME",
  CANDIDATE_DOES_NOT_FIT = "CANDIDATE_DOES_NOT_FIT",
  TOO_MANY_CHECKOUT_EVENTS = "TOO_MANY_CHECKOUT_EVENTS",
  CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION = "CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION",
  DELETE_SOLVED_ORDER_TARGET_NOT_FOUND = "DELETE_SOLVED_ORDER_TARGET_NOT_FOUND",
  PLAN_ENTRY_CANDIDATE_COLLISION = "PLAN_ENTRY_CANDIDATE_COLLISION",
  FORBIDDEN_TAXI = "FORBIDDEN_TAXI",
  FORBIDDEN_PLAN_ENTRY = "FORBIDDEN_PLAN_ENTRY",
  PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR = "PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR",
}

export type DriverPlanNotAcceptableResponseErrorNoTaxiDriverAssociationError = {
  errorType: DriverPlanNotAcceptableResponseErrorType.NO_TAXI_DRIVER_ASSOCIATION;
  driverId: string;
  taxiId: string;
};

export type DriverPlanNotAcceptableResponseErrorNoValidTaxiDriverContractError =
  {
    errorType: DriverPlanNotAcceptableResponseErrorType.NO_VALID_TAXI_DRIVER_CONTRACT;
    driverId: string;
    taxiId: string;
  };

export type DriverPlanNotAcceptableResponseErrorNoValidTaxiRailyContractError =
  {
    errorType: DriverPlanNotAcceptableResponseErrorType.NO_VALID_TAXI_RAILY_CONTRACT;
  };

export type DriverPlanNotAcceptableResponseErrorNoValidCargoRailyContractError =
  {
    errorType: DriverPlanNotAcceptableResponseErrorType.NO_VALID_CARGO_RAILY_CONTRACT;
    driverId: string;
    taxiId: string;
  };

export type DriverPlanNotAcceptableResponseErrorTargetPlanEntryNotFoundError = {
  errorType: DriverPlanNotAcceptableResponseErrorType.TARGET_PLAN_ENTRY_NOT_FOUND;
  candidatureEntryId: string;
  providedPlanEntryId: string;
};

export type DriverPlanNotAcceptableResponseErrorCandidateFitsWithNotEnoughTimeError =
  {
    errorType: DriverPlanNotAcceptableResponseErrorType.CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME;
    candidatureId: string;
    candidatureEntryId: string;
    collidingSolvedOrderId: string;
    candidatureSolvedOrderId: string;
  };

export type DriverPlanNotAcceptableResponseErrorTooManyCheckoutEventsError = {
  errorType: DriverPlanNotAcceptableResponseErrorType.TOO_MANY_CHECKOUT_EVENTS;
};

export type DriverPlanNotAcceptableResponseErrorCandidateDoesNotFitError = {
  errorType: DriverPlanNotAcceptableResponseErrorType.CANDIDATE_DOES_NOT_FIT;
  candidatureId: string;
  candidatureEntryId: string;
  candidatureSolvedOrderId: string;
};

export type DriverPlanNotAcceptableResponseErrorCandidatePlanEntryCollidesError =
  {
    errorType: DriverPlanNotAcceptableResponseErrorType.CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION;
    candidatureId: string;
    candidatureEntryId: string;
    providedPlanEntryId: string;
  };

export type DriverPlanNotAcceptableResponseErrorDeleteSolvedOrderTargetNotFoundError =
  {
    errorType: DriverPlanNotAcceptableResponseErrorType.DELETE_SOLVED_ORDER_TARGET_NOT_FOUND;
    candidatureId: string;
    candidatureEntryId: string;
    targetSolvedOrderId: string;
  };

export type DriverPlanNotAcceptableResponseErrorPlanEntryCandidateCollisionError =
  {
    errorType: DriverPlanNotAcceptableResponseErrorType.PLAN_ENTRY_CANDIDATE_COLLISION;
    candidatureId: string;
    candidatureEntryId: string;
  };

export type DriverPlanNotAcceptableResponseErrorForbiddenTaxiError = {
  errorType: DriverPlanNotAcceptableResponseErrorType.FORBIDDEN_TAXI;
  providedTaxiId: string;
};

export type DriverPlanNotAcceptableResponseErrorForbiddenPlanEntryError = {
  errorType: DriverPlanNotAcceptableResponseErrorType.FORBIDDEN_PLAN_ENTRY;
  providedPlanEntryId: string;
};

export type DriverPlanNotAcceptableResponseErrorPlanEntryCandidateStartTimeExpiredError =
  {
    errorType: DriverPlanNotAcceptableResponseErrorType.PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR;
    candidatureId: string;
    candidatureEntryId: string;
  };

export type DriverPlanNotAcceptableResponseError =
  | DriverPlanNotAcceptableResponseErrorNoTaxiDriverAssociationError
  | DriverPlanNotAcceptableResponseErrorNoValidTaxiDriverContractError
  | DriverPlanNotAcceptableResponseErrorNoValidTaxiRailyContractError
  | DriverPlanNotAcceptableResponseErrorNoValidCargoRailyContractError
  | DriverPlanNotAcceptableResponseErrorTargetPlanEntryNotFoundError
  | DriverPlanNotAcceptableResponseErrorCandidateFitsWithNotEnoughTimeError
  | DriverPlanNotAcceptableResponseErrorCandidateDoesNotFitError
  | DriverPlanNotAcceptableResponseErrorCandidatePlanEntryCollidesError
  | DriverPlanNotAcceptableResponseErrorDeleteSolvedOrderTargetNotFoundError
  | DriverPlanNotAcceptableResponseErrorPlanEntryCandidateCollisionError
  | DriverPlanNotAcceptableResponseErrorForbiddenTaxiError
  | DriverPlanNotAcceptableResponseErrorForbiddenPlanEntryError
  | DriverPlanNotAcceptableResponseErrorTooManyCheckoutEventsError
  | DriverPlanNotAcceptableResponseErrorPlanEntryCandidateStartTimeExpiredError;

export type DriverPlanAcceptErrorResponse =
  HttpResponse<DriverPlanNotAcceptableResponseError>;

export type DriverPlanAcceptSuccessResponse = HttpResponse;

type DriverPlanAcceptResponse =
  | DriverPlanAcceptSuccessResponse
  | DriverPlanAcceptErrorResponse;

export default DriverPlanAcceptResponse;
